import { render, staticRenderFns } from "./AgentInitCall.vue?vue&type=template&id=64d0eb1c&scoped=true&"
import script from "./AgentInitCall.vue?vue&type=script&lang=js&"
export * from "./AgentInitCall.vue?vue&type=script&lang=js&"
import style0 from "./AgentInitCall.vue?vue&type=style&index=0&id=64d0eb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0eb1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VIcon,
})
